(function () {
  function initHomeBestsellersHeader() {
    var headings = document.querySelectorAll('#shopify-section-home .sec-head h2');
    for (var i = 0; i < headings.length; i += 1) {
      if ((headings[i].textContent || '').trim().toLowerCase() !== 'the bestsellers') continue;
      var section = headings[i].closest('.sec');
      if (section) section.classList.add('an-home-bestsellers-mobile');
      break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeBestsellersHeader);
  } else {
    initHomeBestsellersHeader();
  }

  document.addEventListener('shopify:section:load', initHomeBestsellersHeader);
})();
